/* eslint-disable @typescript-eslint/naming-convention */
export interface AbsorbCourseDto {
  Id: string;
  Name: string;
  Description: string;
}
